import axios from 'axios'
import { ElMessage } from 'element-plus'

// 创建axios实例
const service = axios.create({
	// 设置后端API的基础URL
	baseURL: '/api', // 走Vue CLI代理
	timeout: 20000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
	config => {
		// 从localStorage获取token
		const token = localStorage.getItem('token')
		// 如果token存在，则在请求头中添加token
		if (token) {
			config.headers['Authorization'] = `Bearer ${token}`
		}
		return config
	},
	error => {
		console.error('请求错误:', error)
		return Promise.reject(error)
	}
)

// 响应拦截器
service.interceptors.response.use(
	response => {
		const res = response.data
		console.log('接口返回数据:', res)
		// 无论code返回多少都直接return res，由前端自行判断code并处理message/data
		return res
	},
	error => {
		console.error('响应错误详情:', error.response || error)
		const errMsg = error.response?.data?.message || error.message || '请求失败'
		ElMessage({
			message: errMsg,
			type: 'error',
			duration: 5 * 1000
		})
		return Promise.reject(error)
	}
)

export default service 